import Constants from 'expo-constants';
import { captureException, initSentry } from 'util/sentry';
import { getErrorMonitoringDsn } from 'util/util';

const errorMonitoringDsn = getErrorMonitoringDsn();
if (errorMonitoringDsn) {
    initSentry({
        dsn: errorMonitoringDsn,
        environment: process.env.NODE_ENV || 'development',
        release: Constants.expoConfig?.extra?.sentryRelease,
        debug: process.env.NODE_ENV === 'development',
    });

    // Capture uncaught errors (synchronous throws in event handlers, etc.)
    window.addEventListener('error', (event) => {
        captureException(event.error);
    });

    // Capture unhandled promise rejections
    window.addEventListener('unhandledrejection', (event) => {
        captureException(event.reason);
    });

    // Capture console errors
    const originalConsoleError = console.error;
    console.error = (...args) => {
        captureException(new Error(args.join(' ')));
        originalConsoleError.apply(console, args);
    };
}
